import loadScript from '../util/loader';
import isTouch from '../util/touch';

export default async function productNativeVideo(uniqueKey) {
  const playerElement = document.querySelector(`[data-player="${uniqueKey}"]`);
  const videoElement = playerElement.querySelector('video');
  const videoLoad = {
    name: 'video-ui',
    version: '1.0',
  };
  await loadScript(videoLoad);

  const player = new window.Shopify.Plyr(videoElement);
  playerElement.addEventListener('pause', function () {
    if (player.pause) {
      player.pause();
    }
  });
  playerElement.addEventListener('play-desktop', function () {
    if (player.play && !isTouch()) {
      playerElement.dispatchEvent(new CustomEvent('play'));
    }
  });
  playerElement.addEventListener('play', function () {
    try {
      if (player.play) {
        player.play();
      } else {
        player.addEventListener('onReady', function (event) {
          event.target.play();
        });
      }
    } catch (e) {
      console.warn(e);
    }
  });
  playerElement.addEventListener('destroy', function () {
    try {
      if (player.destroy) {
        player.destroy();
      }
    } catch (e) {
      console.warn(e);
    }
  });
  return player;
}
